import URL from '@/api/URL';
import fetch from '@/api/fetch';

export function getCompanyList (params) {
  return fetch.post(URL.getCompanyList, params);
}

export function getOrgListForInputEv (params) {
  return fetch.post(URL.getOrgListForInputEv, params);
}

export function getInputEvList (params) {
  return fetch.post(URL.getInputEvList, params);
}

export function exportInputEvList (params) {
  return fetch.post(URL.exportInputEvList, params);
}

export function getInputEvDetail (params) {
  return fetch.post(URL.getInputEvDetail, params);
}

export function selectOutputEvList (params) {
  return fetch.post(URL.selectOutputEvList, params);
}

export function selectDataDirInit (params) {
  return fetch.post(URL.selectDataDirInit, params);
}

export function selectDataDirInfoList (params) {
  return fetch.post(URL.selectDataDirInfoList, params);
}



// WEBPACK FOOTER //
// ./src/api/modules/exEvidenceAdmin.js